<template>
	<ja-modal ref="modal" :show="show" class="modal-wrapper">
		<content class="pause-modal">
			<div class="inner-avatar">
				<img :src="require(`@/assets/images/Jimmy.png`)" alt="jimmy-img" />
			</div>
			<div v-if="userData" class="content-wrapper">
				<h1>
					{{ $t('hey') }}
					{{ lifeStageData.formStudentName ?? userData.firstName }},
				</h1>
				<h4>{{ $t('pauseModalSubtitle') }}</h4>
				<svgicon name="pause-sim"></svgicon>
			</div>
		</content>
	</ja-modal>
</template>
<script>
import '../icons/pause-sim';
import Modal from './Modal';
import UserData from '../../mixins/UserData';
import ModalEvents from '../../mixins/ModalEvents';
import lifeStageData from '../../mixins/LifeStageData.vue';

export default {
	components: {
		jaModal: Modal
	},
	mixins: [UserData, ModalEvents, lifeStageData],
	props: {
		show: {
			type: Boolean,
			default: false
		}
	}
};
</script>

<style lang="scss" scoped>
.modal-wrapper {
	z-index: 1000;

	.pause-modal {
		padding: 70px 70px 32px 70px;

		h1 {
			margin: 0;
		}

		h5 {
			margin: 8px 0;
		}

		.inner-avatar {
			position: relative;
			top: -125px;
			margin-bottom: -120px;
			background-color: #ffffff;
			border-radius: 50%;
			border: 4px solid #e7f8ff;
			width: 110px;
			height: 110px;

			img {
				width: 75px;
			}
		}
		.content-wrapper {
			width: 60%;
			height: 300px;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: space-around;

			svg {
				height: 52px;
				width: 52px;
				color: #dde4e6;
				margin-top: 15px;
				margin-bottom: 32px;
			}
		}
	}
}
</style>
